module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Spy-c5414dfc5ebef04c9644cc45dd9537a1.svg";